<template>
  <div class="activestatistics">
    <div class="header">
      <label style="margin-right: 20px;">{{ $t('Education.languages22')}}</label>
      <el-select v-model="params.itemType" clearable :placeholder="$t('Education.languages18')">
        <el-option
            v-for="item in trainingstate"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-input v-model="params.searchValue" clearable  placeholder="请输入主题查询" style="width: 200px;margin:0 30px"></el-input>
      <el-button type="primary" @click="handleCurrentChange(1)">{{ $t('Education.languages01') }}</el-button>
      <el-button type="primary" @click="ClickExport">{{ $t('Education.languages20') }}</el-button>
      <el-button type="primary" @click="reset">重置</el-button>
    </div>

    <div class="content">
      <el-table
          v-loading="loading"
          :data="trainData"
          :cell-style="{'text-align':'center'}"
          style="width: 100%">
        <el-table-column prop="itemType" label="主题类型"></el-table-column>
        <el-table-column prop="itemName" label="主题"></el-table-column>
        <el-table-column prop="clicks" label="点击"> </el-table-column>
        <el-table-column prop="likes" label="点赞"> </el-table-column>
        <el-table-column prop="comments" label="评论"> </el-table-column>
        <el-table-column prop="shares" label="分享"> </el-table-column>
      </el-table>

      <el-pagination
      style="margin-top: 20px;"
      hide-on-single-page
      @current-change="handleCurrentChange"
      :current-page.sync="params.pageNum"
      :page-size="params.pageSize"
      layout="total, prev, pager, next"
      :total="params.Total">
      </el-pagination>
    </div>
  </div>
</template>

<script>

export default ({
  name:'activestatistics',
  data(){
    return{
      loading:true,
      trainingstate:[
        {value: '1',label: '培训考试'}, 
        {value: '2',label: '课程考试'}, 
        {value: '3',label: '章节考试'}
      ],
      trainData:[],
      params:{
        pageNum:1,
        pageSize:10,
        searchValue:'',
        itemType:'',
        Total:0
      }
    }
  },
  created() {
    this.getActiveStatistics();
  },
  methods:{
    getActiveStatistics(){
      this.loading=true;
      this.$Http_Post('edu/active/getActiveStatistics',this.params).then(res=>{
        if(res.Code==0){
          this.trainData=res.Data;
          this.params.Total=res.Counts
        }else{
          this.$message({type: 'error', message:res.Message});
        }
        this.loading=false;
      })
    },
    handleCurrentChange(val){
      this.params.pageNum=val;
      this.getActiveStatistics();
    },
    // 重置
    reset(){
      this.params=this.$options.data().params;
      this.getActiveStatistics();
    },
    ClickExport(){
      location.href=process.env.VUE_APP_URL+'edu/active/exportActiveStatistics?searchValue='+this.params.searchValue+'&itemType='+this.params.itemType
    }
  },
})
</script>
<style scoped>
.header{display: flex;align-items:center;background: #fff;padding:20px 30px;;}
.content{background:#fff;padding:30px;margin-top:20px;}
.Proportion{padding:0 30px;}
.Proportion span{background:#78bbff;color: #fff;display: inline-block;text-align: center;width: 50%;border-radius: 20px 0 0 20px;}
.Proportion label{display: inline-block;text-align: center;width: 50%;border-radius:0 20px 20px 0;background:#ffd3a5;color: #fff;}
</style>